(function(){
'use strict';

angular.module('classy').factory('PaymentGateway', function () {
  function PaymentGateway() {}

  // gateway props depend on payment method?
  return PaymentGateway;
});
})();